import {useNavigate} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import {styled} from "@mui/material/styles";
import MuiBottomNavigationAction from "@mui/material/BottomNavigationAction";
import BottomNavigation from "@mui/material/BottomNavigation";
import Typography from "@mui/material/Typography";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";

   const BackButton = () => {
        let navigate = useNavigate();


        return (
            <IconButton
                onClick={() =>navigate(-1)}
                style={{ color: 'black' ,marginRight: 8 }}
                size="large"><ArrowBackIcon/></IconButton>
        );
    }

    const BottomMenu = () => {
        const [value, setValue] = React.useState("");
        // const navigate = useNavigate()
        const BottomNavigationAction = styled(MuiBottomNavigationAction)(`
  color: rgba(0,0,0,1);
  &.Mui-selected {
    color: black;
  }
`);

        return (<BottomNavigation

                style={{
                    width: '100%',
                    background: 'rgba(232,232,232,0.3)',
                    position: 'fixed',
                    fontFamily: "IRANSans",
                    bottom: 0,
                }}
                showLabels
                value={value}
                onChange={(event, newValue) => {
                    window.location.assign(newValue);

                    setValue(newValue);
                }}>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>پیام رسان</Typography>}
                                        value="messenger/dialogs" icon={<SmsOutlinedIcon/>}/>
                <BottomNavigationAction
                    label={<Typography style={{fontSize: 12,}}>پروفایل</Typography>} value="profile"
                    icon={<AccountCircleIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>محصولات</Typography>} value="offers"
                                        icon={<DnsOutlinedIcon/>}/>
                <BottomNavigationAction label={<Typography style={{fontSize: 12,}}>فروشگاه‌ها</Typography>} value="/"
                                        icon={<StorefrontOutlinedIcon/>}/>

            </BottomNavigation>
        )
    }

export {BackButton,BottomMenu}




